export const applyDesignSystemSummaryCollection = function applyDesignSystemSummaryCollection() {
    const dataDesignSystem = this.getDesignSystem()
    const s = dataDesignSystem.color ? dataDesignSystem : this.context.designSystem

    if (!s) return

    const {
      color,
      theme,
      typography,
      font,
      fontFamily,
      spacing,
      icons,
      timing,
      cases,
      GRIDS,
      media,
      devices
    } = s

    if (!color) return

    return [{
      icon: 'colorOutline',
      href: '/color',
      iconTheme: 'theme',
      title: 'colors',
      paragraph: 'Theming of an entire app',
      iconBackground: 'red',
      properties: [{
        property: 'Colors',
        value: color && Object.keys(color).length
      }, {
        property: 'Themes',
        value: theme && Object.keys(theme).length
      }]
    }, {
      icon: 'typographyOutline',
      href: '/typography',
      iconTheme: 'typography',
      title: 'typography',
      paragraph: 'Style a typed material',
      properties: [{
        property: 'Base size',
        value: typography && typography.base + 'px'
      }, {
        property: 'Ratio',
        value: typography && typography.ratio
      }, {
        property: 'Styles',
        value: typography && typography.styles && Object.keys(typography.styles).length
      }]
    }, {
      icon: 'spaceOutline',
      href: '/spacing',
      iconTheme: 'space',
      title: 'Spacing',
      paragraph: 'Manage sizing properties of a space',
      properties: [{
        property: 'Ratio',
        value: spacing && spacing.ratio
      }, {
        property: 'Templates',
        value: 'TBA'
      }]
    }, {
      icon: 'shape',
      href: '/shape',
      iconTheme: 'shape',
      title: 'shapes',
      paragraph: 'Design an outline to a chosen component',
      properties: [{
        property: 'HTML',
        value: '32'
      }, {
        property: 'SVG',
        value: 'TBA'
      }]
    }, {
      icon: 'iconsOutline',
      href: '/icons',
      iconTheme: 'color',
      title: 'Icons',
      paragraph: 'Label a role of subject with glyphs',
      properties: [{
        property: 'All',
        value: icons && Object.keys(icons).length
      }, {
        property: 'Fill',
        value: icons && Object.keys(icons).filter(v => v.toLowerCase().includes('fill')).length
      }, {
        property: 'Linear',
        value: icons && Object.keys(icons).filter(v => v.toLowerCase().includes('outline')).length
      }, {
        property: 'Colored',
        value: icons && Object.keys(icons).filter(v => v.toLowerCase().includes('colored')).length
      }]
    }, {
      icon: 'fontFace',
      href: '/font',
      title: 'Fonts',
      paragraph: 'Fonts and font families',
      properties: [{
        property: 'Fonts',
        value: font && Object.keys(font).length
      }, {
        property: 'Families',
        value: fontFamily && Object.keys(fontFamily).length
      }]
    }, {
      icon: 'clock',
      href: '/timing',
      iconTheme: 'icons',
      title: 'Timing',
      paragraph: 'Tokens for transitions and animations',
      properties: [{
        property: 'Timing base',
        value: timing && timing.base + 'ms'
      }, {
        property: 'Ratio',
        value: timing && timing.ratio
      }, {
        property: 'Transitions',
        value: 'TBA'
      }, {
        property: 'Animations',
        value: 'TBA'
      }]
    }, {
      icon: 'layout outline',
      href: '/grid',
      title: 'Grids',
      paragraph: 'Grid systems for consistant layout',
      properties: [{
        property: 'All grids',
        value: GRIDS && Object.keys(GRIDS).length
      }]
    }, {
      icon: 'boolean outline',
      href: '/cases',
      title: 'Cases',
      paragraph: 'Conditional cases of UA reused in properties',
      properties: [{
        property: 'All cases',
        value: cases && Object.keys(cases).length
      }]
    }, {
      icon: 'deviceMobile',
      href: '/media',
      title: 'Breakpoints',
      paragraph: 'Device breakpoints as media and container queries',
      properties: [{
        property: 'Breakpoints',
        value: media && Object.keys(media).length
      }, {
        property: 'Screens',
        value: devices && Object.keys(devices).length
      }]
    }, {
      icon: 'threeDots',
      href: '/sequence',
      title: 'Sequence',
      paragraph: 'Mapping system of generative sizing units',
      properties: [{
        property: 'Breakpoints',
        value: '8'
      }, {
        property: 'Screens',
        value: '3'
      }]
    }]
  }